import api from './api';

const BASE = '/canteen';

const canteenService = {

  getToday: async () => {
    const { data } = await api.get(`${BASE}/today`);
    return data;
  },

  getMonthMenus: async (year, month) => {
    const { data } = await api.get(`${BASE}/menus`, { params: { year, month } });
    return data;
  },

  getMonthStatus: async (year, month) => {
    const { data } = await api.get(`${BASE}/status`, { params: { year, month } });
    return data;
  },

  saveMenu: async (payload) => {
    const { data } = await api.post(`${BASE}/menus`, payload);
    return data;
  },

  bulkSave: async (menus, status = 'DRAFT') => {
    const { data } = await api.post(`${BASE}/bulk-save`, { menus, status });
    return data;
  },

  publishMonth: async (year, month, status = 'PUBLISHED') => {
    const { data } = await api.post(`${BASE}/publish`, { year, month, status });
    return data;
  },

  deleteMenu: async (id) => {
    await api.delete(`${BASE}/menus/${id}`);
  },

  clearMonth: async (year, month) => {
    await api.delete(`${BASE}/clear-month`, { params: { year, month } });
  },
};

export default canteenService;